import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { StorageKeys } from '../../shared/enums/storage-keys.enum';
import { StorageService } from '../../shared/services/storage.service';

const TUOTEMPO_HEADER = 'Tuotempo';

function isCitaSessionUrl(url: string): boolean {
  return url.includes('/api/private/citas') || url.includes('/api/private/videocall');
}

export const citaSessionInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  let request = req;

  if (isCitaSessionUrl(req.url)) {
    const userLoginRequester = storageService.sessionStorageGetItem(StorageKeys.USER_LOGIN_REQUESTER);
    const tokenCita = storageService.sessionStorageGetItem(StorageKeys.CITA_TOKEN);

    if (!userLoginRequester && tokenCita && !req.headers.has(TUOTEMPO_HEADER)) {
      request = req.clone({
        setHeaders: { [TUOTEMPO_HEADER]: tokenCita },
      });
    }
  }

  return next(request).pipe(
    tap(event => {
      if (!(event instanceof HttpResponse) || !isCitaSessionUrl(event.url ?? request.url)) {
        return;
      }

      const tuotempo = event.headers.get(TUOTEMPO_HEADER);
      if (tuotempo) {
        storageService.sessionStorageSetItem(StorageKeys.CITA_TOKEN, tuotempo);
      }
    })
  );
};
